"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeneric = void 0;
/**
 * Determine if the given type is a generic reference or a concrete value type.
 * @param type The type to check.
 * @returns True if the type is a generic reference.
 */
function isGeneric(type) {
    return typeof type === "object" && type.hasOwnProperty("genericIdentifier");
}
exports.isGeneric = isGeneric;
//# sourceMappingURL=generic.js.map